import React from 'react';
import LocalUrlMaker from "../lib/LocalUrlMaker";
import PropTypes from "prop-types";
import RemoveItemsRow from "./RemoveItemsRow";

// FIXME: legacy css

function ItemCell({item}) {
  let path = LocalUrlMaker.prefixedPath(item.path);
  let {img} = item;

  return <th>
    <div className="title"><a href={path}>{item.name}</a></div>
    {img && <div className="pic"><a href={path}><img src={img} alt={item.name}/></a></div>}
  </th>
}

ItemCell.propTypes = {
  item: PropTypes.object.isRequired
}

export default function TableHead({items = [], hideItem}) {
  return (
    <thead>
    <tr>
      <th className=""></th>
      {items.map((item) => <ItemCell item={item} key={item.id}/>)}
    </tr>
    <RemoveItemsRow items={items} hideItem={hideItem}/>
    </thead>
  );
}

TableHead.propTypes = {
  items: PropTypes.array.isRequired,
  hideItem: PropTypes.func.isRequired
}
